var map = {
	"./angle-right.svg": 564,
	"./angle-up.svg": 138,
	"./clock.svg": 550,
	"./email.svg": 369,
	"./hamburger.svg": 969,
	"./kma.svg": 681,
	"./linkedin.svg": 665,
	"./location.svg": 848,
	"./minus.svg": 820,
	"./nav-arrow.svg": 627,
	"./opening-quote.svg": 784,
	"./phone.svg": 79,
	"./play.svg": 354,
	"./plus.svg": 886,
	"./search.svg": 127,
	"./star.svg": 567,
	"./times.svg": 754
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 619;